// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-menu {
  background: #fff;
  padding: 15px 8px;
  width: 165px; /* Fixed width */
  height: 100vh; /* Full height of viewport */
  position: fixed;
  right: 0; /* Position it on the right */
  top: 0px;
  z-index: 1; /* Ensures it's above other content */
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0; /* Sidebar is fully square */
  overflow-y: auto; /* Enables scrolling */
  background-color: #fafafa;
  padding-bottom: 65px;
}

/* Hide scrollbar for clean UI */
.sidebar-menu::-webkit-scrollbar {
  width: 5px;
}

.sidebar-menu::-webkit-scrollbar-thumb {
  background: #aaa;
  border-radius: 5px;
}

.sidebar-menu .menu-title {
  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin-bottom: 10px;
  border-bottom: 2px solid #ccc;
  padding-bottom: 5px;
}

/* Stack elements in a column */
.sidebar-menu .menu-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Center icon and text, increase height */
.sidebar-menu .menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 90px;
  border-radius: 8px; /* Buttons and items still have rounded corners */
  transition: background 0.3s;
  cursor: pointer;
}

.sidebar-menu .menu-item:hover {
  background: #f1f1f1;
}

/* Custom icon colors & size */
.sidebar-menu .icon.text {
  color: #007bff; /* Blue for Text */
  font-size: 21px; /* Updated size */
  margin-bottom: 5px;
}

.sidebar-menu .icon.image {
  color: #dc3545; /* Red for Image */
  font-size: 25px; /* Updated size */
  margin-bottom: 5px;
  margin-top: 16px;
}

.sidebar-menu p {
  font-size: 14px;
  color: #333;
  margin-top: 5px;
}

/* Content Blocks - Taller */
.sidebar-menu .content-blocks {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}

.sidebar-menu .block-item {
  width: 100%;
  height: 125px;
  background: #eaeaea;
  border: 1px solid #ccc;
  border-radius: 8px; /* Content blocks still have rounded corners */
  cursor: pointer;
  transition: background 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  overflow: hidden;
}

.sidebar-menu .block-item:hover {
  background: #dcdcdc;
}
`, "",{"version":3,"sources":["webpack://./src/components/birthday/SidebarMenu.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY,EAAE,gBAAgB;EAC9B,aAAa,EAAE,4BAA4B;EAC3C,eAAe;EACf,QAAQ,EAAE,6BAA6B;EACvC,QAAQ;EACR,UAAU,EAAE,qCAAqC;EACjD,yCAAyC;EACzC,gBAAgB,EAAE,4BAA4B;EAC9C,gBAAgB,EAAE,sBAAsB;EACxC,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB,EAAE,iDAAiD;EACrE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,cAAc,EAAE,kBAAkB;EAClC,eAAe,EAAE,iBAAiB;EAClC,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,kBAAkB;EAClC,eAAe,EAAE,iBAAiB;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB,EAAE,8CAA8C;EAClE,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".sidebar-menu {\r\n  background: #fff;\r\n  padding: 15px 8px;\r\n  width: 165px; /* Fixed width */\r\n  height: 100vh; /* Full height of viewport */\r\n  position: fixed;\r\n  right: 0; /* Position it on the right */\r\n  top: 0px;\r\n  z-index: 1; /* Ensures it's above other content */\r\n  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);\r\n  border-radius: 0; /* Sidebar is fully square */\r\n  overflow-y: auto; /* Enables scrolling */\r\n  background-color: #fafafa;\r\n  padding-bottom: 65px;\r\n}\r\n\r\n/* Hide scrollbar for clean UI */\r\n.sidebar-menu::-webkit-scrollbar {\r\n  width: 5px;\r\n}\r\n\r\n.sidebar-menu::-webkit-scrollbar-thumb {\r\n  background: #aaa;\r\n  border-radius: 5px;\r\n}\r\n\r\n.sidebar-menu .menu-title {\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  color: #2a2a2a;\r\n  margin-bottom: 10px;\r\n  border-bottom: 2px solid #ccc;\r\n  padding-bottom: 5px;\r\n}\r\n\r\n/* Stack elements in a column */\r\n.sidebar-menu .menu-grid {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n/* Center icon and text, increase height */\r\n.sidebar-menu .menu-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 90px;\r\n  border-radius: 8px; /* Buttons and items still have rounded corners */\r\n  transition: background 0.3s;\r\n  cursor: pointer;\r\n}\r\n\r\n.sidebar-menu .menu-item:hover {\r\n  background: #f1f1f1;\r\n}\r\n\r\n/* Custom icon colors & size */\r\n.sidebar-menu .icon.text {\r\n  color: #007bff; /* Blue for Text */\r\n  font-size: 21px; /* Updated size */\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.sidebar-menu .icon.image {\r\n  color: #dc3545; /* Red for Image */\r\n  font-size: 25px; /* Updated size */\r\n  margin-bottom: 5px;\r\n  margin-top: 16px;\r\n}\r\n\r\n.sidebar-menu p {\r\n  font-size: 14px;\r\n  color: #333;\r\n  margin-top: 5px;\r\n}\r\n\r\n/* Content Blocks - Taller */\r\n.sidebar-menu .content-blocks {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.sidebar-menu .block-item {\r\n  width: 100%;\r\n  height: 125px;\r\n  background: #eaeaea;\r\n  border: 1px solid #ccc;\r\n  border-radius: 8px; /* Content blocks still have rounded corners */\r\n  cursor: pointer;\r\n  transition: background 0.3s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  overflow: hidden;\r\n}\r\n\r\n.sidebar-menu .block-item:hover {\r\n  background: #dcdcdc;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
